<template>
  <v-container
    fluid
    class='pa-5'
  >
  <v-card flat>
    <v-card-title class='title'>National cycling statistics</v-card-title>
    <v-card-text class='sub-text'>
      Statistics taken from a range of sources examining different Active Travel Framework
      indicators around cycling in Scotland, including:
      cycle numbers, quality of infrastructure, safety, delivery and availability.
    </v-card-text>
  </v-card>
    <v-row>
      <v-col
        cols='12'
        xs='12'
        md='6'
      >
        <ModeShare />
      </v-col>
      <v-col
        cols='12'
        xs='12'
        md='6'
      >
        <SafetyStatisticsCard />
      </v-col>
      <v-col
        cols='12'
        xs='12'
        md='6'
      >
        <CycleRouteInfoCard />
      </v-col>
      <v-col
        cols='12'
        xs='12'
        md='6'
      >
        <AttitudesCard />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols='12'
        xs='12'
      >
        <CyclingToSchool />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CycleRouteInfoCard from '@/components/cycleRouteInfoCard.vue';
import AttitudesCard from '@/components/attitudesCard.vue';
import CyclingToSchool from '@/components/cyclingToSchoolCard.vue';
import SafetyStatisticsCard from '@/components/safetyStatisticsCard.vue';
import ModeShare from '@/components/modeShareCard.vue';

export default {
  components: {
    CycleRouteInfoCard,
    AttitudesCard,
    CyclingToSchool,
    SafetyStatisticsCard,
    ModeShare,
  },
};
</script>

<style lang="scss" scoped>
.spacing {
  padding: 10px !important;
}
.title {
  color: #5a5959;
  font-size: 18px;
  font-weight: bold;
}
</style>
